// extracted by mini-css-extract-plugin
export default {"card_title":"home_card_title__enoqs","card_number":"home_card_number__nU4kL"};